import { observer } from 'mobx-react';

import styles from './TranslationSelect.module.scss';

import { Select } from '@components/Select';
import { translate } from '@chaika/i18n/helper';
import { LeftTitle } from '@components/LeftTitle';
import { LeftTitleModifiers } from '@components/LeftTitle/LeftTitle';
import { EntryTranslation } from '@patient/store/entry/EntryTranslation';
import { useTranslationSelect } from '@patient/ui/shared/TranslationSelect/hooks/useTranslationSelect';

interface Props {
    fromSoap?: boolean;
    confirmedTranslations: EntryTranslation[];
}

export const TranslationSelect = observer(({ confirmedTranslations, fromSoap }: Props) => {
    const { onChange, selectedValue, confirmedTranslationOptions, isMobileSize } = useTranslationSelect({
        confirmedTranslations,
        fromSoap,
    });

    return (
        <div className={styles.root}>
            <LeftTitle
                light
                modifiers={[LeftTitleModifiers.SmallGap]}
                customTitleWidth={isMobileSize ? undefined : 52}
                title={translate('entryLanguage')}
            >
                <div className={styles.select}>
                    <Select
                        withDefaultValue
                        selectedValue={selectedValue}
                        widthByContent
                        onChange={onChange}
                        options={confirmedTranslationOptions}
                    />
                </div>
            </LeftTitle>
        </div>
    );
});
